// src/collectTelemetry.js
export async function collectTelemetry(endpointUrl) {
  try {
    const data = {
      timestamp: new Date().toISOString(),
      page: window.location.pathname + window.location.search,
      referrer: document.referrer || '',
      userAgent: navigator.userAgent || '',
      platform: navigator.platform || '',
      languages: navigator.languages ? navigator.languages.join(',') : navigator.language,
      screen: `${window.screen.width}x${window.screen.height}`,
      devicePixelRatio: window.devicePixelRatio || 1,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
      cookieEnabled: navigator.cookieEnabled,
      doNotTrack:
        navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack || '',
    };

    console.log('[telemetry] payload:', data);

    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(endpointUrl, blob);
      return { ok: true, data };
    } else {
      const resp = await fetch(endpointUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      return { ok: resp.ok, status: resp.status, data };
    }
  } catch (err) {
    console.error('collectTelemetry error:', err);
    return { ok: false, error: err.message };
  }
}
